export default __webpack_public_path__ + "static/media/Snd_TryV.d563fbb0.mp3";